<!-- 编辑沟通小结 -->
<template>
  <div>
    <a-drawer
      title="沟通小结"
      width="726px"
      v-model:visible="showAddSummaryAlter"
      :maskClosable="false"
      :drawerStyle="{ backgroundColor: '#F5F5F5', display: 'flex', flexDirection: 'column' }"
      :bodyStyle="{
        padding: 0,
        paddingBottom: '53px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }"
      :closable="false"
      :keyboard="false"
    >
      <div class="patient-info">
        <div v-if="groupInfo.bdUcUserId" class="user-info-wrap">
          <div class="line">
            <div class="user-info-item">
              <span>BD姓名：</span>
              {{ groupInfo.bdName }}
            </div>
          </div>
        </div>
        <div class="user-info-wrap">
          <div class="line">
            <div v-if="isPre || groupInfo.doctorName" class="user-info-item">
              <span>医生姓名：</span>
              {{ groupInfo.doctorName || '暂无' }}
            </div>
            <a-select
              v-else
              allowClear
              class="user-info-select"
              v-model:value="selDoctor.ucDoctorId"
              show-search
              placeholder="请选择医生"
              :filter-option="filterOption"
              :options="selDoctor.options"
              @change="(val, option) => onSelect(3, option)"
            ></a-select>
          </div>
          <div class="line">
            <div
              v-if="isPre || groupInfo.patientProfileCommonVO?.patientProfileName"
              class="user-info-item"
            >
              <span>患者姓名：</span>
              {{ groupInfo.patientProfileCommonVO?.patientProfileName || '暂无' }}
            </div>
            <a-select
              v-else
              allowClear
              show-search
              class="user-info-select"
              v-model:value="selPatient.ucPatientId"
              placeholder="请选择患者"
              :options="selPatient.options"
              :filterOption="filterOption"
              @change="(val, option) => onSelect(2, option)"
            ></a-select>
            <div class="user-info-item">
              <span>性别：</span>
              {{ Config.GENDER[groupInfo.patientProfileCommonVO?.gender] || '-' }}
            </div>
            <div class="user-info-item">
              <span>年龄：</span>
              {{ groupInfo.patientProfileCommonVO?.age || '-' }}
            </div>
          </div>
        </div>
      </div>
      <a-form
        :rules="rules"
        class="add-summary-form"
        layout="vertical"
        ref="formRef"
        :model="summaryForm"
      >
        <div class="basic">
          <a-form-item name="sourceType" label="小结来源：">
            <a-radio-group v-model:value="sourceType" disabled>
              <a-radio :value="1">预问诊</a-radio>
              <a-radio :value="2">AI 生成</a-radio>
              <a-radio :value="3">虚拟电话</a-radio>
              <a-radio :value="4">医助创建</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item name="chatType" label="沟通方式：" v-if="[3, 4].includes(sourceType)">
            <a-radio-group
              v-model:value="summaryForm.callChatSummaryVO.chatType"
              :disabled="isEdit"
            >
              <a-radio :value="1">IM</a-radio>
              <a-radio :value="2">虚拟电话</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            name="cdrIds"
            v-if="summaryForm.callChatSummaryVO.chatType === 2"
            label="电话记录："
          >
            <a-select
              mode="multiple"
              v-model:value="summaryForm.cdrIds"
              style="width: 500px"
              :options="cdrList"
              placeholder="请选择"
            ></a-select>
          </a-form-item>
          <a-form-item name="actualIntent" label="实际诉求：" v-if="selCdrItem?.actualIntent">
            <a-space direction="vertical">
              <a-radio-group
                v-model:value="summaryForm.actualIntent"
                :options="actualDemandOptions"
              />
            </a-space>
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 24 }"
            class="content-form-item"
            name="selectHistorytext"
            label="小结聊天记录："
            @click="openChatHistory()"
            v-if="sourceType === 4 && summaryForm.callChatSummaryVO.chatType === 1"
          >
            <div class="search-input" style="color: #999999">
              <span>{{ selectHistorytext }}</span>
              <RightOutlined class="right-icon" />
            </div>
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 24 }"
            name="contents"
            class="textarea-form-item"
            :style="{ marginBottom: '10px' }"
          >
            <template v-slot:label>
              <div class="custom-label">
                <span class="text">小结内容：</span>
              </div>
            </template>
            <div v-if="summaryType === 1">
              <div
                v-for="(sum, suIndex) in GuideLablesConfigNoImg"
                :key="suIndex"
                class="aiFormItem"
              >
                <span class="labels">{{ sum.label }}：</span>
                <a-input
                  class="search-input"
                  v-model:value="aiSummaryContents[sum.key]"
                  :placeholder="`请输入${sum.label}`"
                  allowClear
                />
              </div>
            </div>
            <div v-else>
              <a-textarea
                class="search-input textarea"
                @input="e => textareaInput(e, 'contents')"
                :value="summaryForm.contents"
                :maxlength="500"
                placeholder="请输入小结内容"
              ></a-textarea>
              <div class="text-tips">{{ summaryForm.contents?.length }}/500</div>
            </div>
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 24 }"
            name="imageList"
            class="textarea-form-item"
            v-if="summaryType === 1"
          >
            <template v-slot:label>
              <div class="custom-label">
                <span class="text">疾病相关图片资料</span>
              </div>
            </template>
            <UploadEdit
              @onSuccess="onSuccess"
              :canEditName="false"
              @updetaList="onSuccess"
              :fileList="fileList"
              :maxLength="20"
            />
          </a-form-item>
          <!-- 未购买原因 -->
          <div v-if="summaryForm?.callChatSummaryVO?.notBuyReasonType" class="notBuyReason">
            <div class="Reason_header">
              <h3 class="Reason_title">填写未购买原因：</h3>
              <span class="Reason_tips">
                (目前检测患者仍未购买处方，如需完成工单，请填写未购原因)
              </span>
            </div>
            <a-form-item name="notBuyReasonType" label="">
              <a-radio-group
                v-model:value="summaryForm.callChatSummaryVO.notBuyReasonType"
                @change="
                  () => {
                    summaryForm.callChatSummaryVO.notBuyOtherReason = ''
                  }
                "
              >
                <a-radio
                  v-for="option in ReasonTypeOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item
              v-if="summaryForm.callChatSummaryVO.notBuyReasonType === 5"
              name="notBuyOtherReason"
            >
              <a-textarea
                :maxlength="100"
                :rows="4"
                showCount
                v-model:value="summaryForm.callChatSummaryVO.notBuyOtherReason"
                placeholder="请填写未购买原因"
                allow-clear
              />
            </a-form-item>
          </div>
        </div>
        <div v-if="sourceType === 3" class="others-box">
          <div>
            <div class="title">
              <div class="left">其他补充</div>
              <div class="right" @click="handleFold">{{ othersShow ? '收起' : '展开' }}</div>
            </div>
            <div class="others" v-show="othersShow">
              <a-form-item name="diagnose">
                <template v-slot:label>
                  <span class="custom-label">诊断：</span>
                </template>
                <div class="diagnose">
                  <a-select
                    id="diagnose"
                    v-model:value="selectDiagnosesId"
                    :mode="'multiple'"
                    placeholder="请输入诊断"
                    :filter-option="false"
                    @search="getDiagnosisList"
                    @change="handleDiagonse"
                    :options="diagnosisList"
                    :getPoppupContainer="trigger => trigger.parentNode"
                    notFoundContent="暂无搜索数据，请输入有效内容"
                  ></a-select>
                </div>
              </a-form-item>
              <a-form-item
                name="medicalConditionContent"
                label="病情补充："
                class="textarea-form-item"
              >
                <a-textarea
                  class="search-input textarea"
                  @input="e => textareaInput(e, 'medicalConditionContent')"
                  :value="summaryForm.callChatSummaryVO?.medicalConditionContent"
                  :maxlength="200"
                  :rows="4"
                  placeholder="请描述患者症状、发病时长、病情程度等"
                ></a-textarea>
                <div class="text-tips">
                  {{ summaryForm?.callChatSummaryVO?.medicalConditionContent?.length }}/200
                </div>
              </a-form-item>
              <a-form-item name="treatmentContent" label="治疗情况：" class="textarea-form-item">
                <a-textarea
                  class="search-input textarea"
                  @input="e => textareaInput(e, 'treatmentContent')"
                  :value="summaryForm.callChatSummaryVO?.treatmentContent"
                  :maxlength="200"
                  :rows="4"
                  placeholder="请填写用药药品，用法用量，持续时间或就医情况等"
                ></a-textarea>
                <div class="text-tips">
                  {{ summaryForm?.callChatSummaryVO?.treatmentContent?.length }}/200
                </div>
              </a-form-item>
            </div>
          </div>
        </div>
      </a-form>
      <div class="footer">
        <a-button @click="cancelConfirm" style="margin-right: 8px">取消</a-button>
        <a-button type="primary" :loading="loading" @click="submit">保存</a-button>
      </div>
    </a-drawer>
    <a-modal
      title="小结聊天记录"
      v-model:visible="selectChatHistoryAlter"
      :destroyOnClose="true"
      width="1059px"
      :bodyStyle="{
        height: '600px',
        padding: '0'
      }"
      :maskClosable="false"
      :closable="false"
    >
      <Chat
        @checkboxChange="checkboxChange"
        :showTabs="false"
        :showCheckbox="true"
        :privateId="privateId"
        :selectHistoryList="selectHistoryList"
        :maxCheckedLength="99"
      />
      <div class="footer">
        <a-button @click="cancelHistory" style="margin-right: 8px">取消</a-button>
        <a-button type="primary" :loading="loading" @click="confirmHistory">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, reactive, createVNode, defineEmits, nextTick, defineExpose, computed } from 'vue'
import Chat from '@/views/WorkPlace/Container/chat/history.vue'
import Config from '@/config/index'
import moment from 'moment'
import { min, max, throttle, cloneDeep, debounce } from 'lodash'
import { createSummary, pushSummary, editSummary, searchDiagnosis } from '@/api/workPlace/summary'
import { Modal, message } from 'ant-design-vue'
import { ExclamationCircleOutlined, RightOutlined } from '@ant-design/icons-vue'
import { filterEmoij } from '@/utils/index.js'
import { useStore } from 'vuex'
import {
  // getCdrList,
  getCdrPelList,
  getDoctorPatients,
  getGroupByUcUserIds
} from '@/api/login'
import useStage from './useStage'
import { GuideLablesConfigNoImg } from '@/views/WorkPlace/Container/chat/components/message/config.js'
import UploadEdit from '@/components/UploadEdit'
import {
  feedbackReasonList,
  getPrescriptionPurchaseByWorkOrderId,
  isShowRecommendDoctor
} from '@/api/chat'
import { TYPE } from '@/constants/columns'
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
const route = useRoute()

const { getStageData, setStorageData, clearStorageData } = useStage()
const store = useStore()
const privateId = ref(null)
const groupInfo = ref({})
const isEdit = ref(false)
const formRef = ref()
const selectHistorytext = ref('')
const othersShow = ref(true)
const diagnosisList = ref([])
const selectDiagnosesId = ref([])
const selectDiagnosesList = ref([])
const sourceType = ref(null)
const cdrList = ref([])

// 判断是预注册患者和未知用户
const isPre = ref()
const selPatient = reactive({
  options: [],
  ucPatientId: undefined,
  patientName: ''
})
const selDoctor = reactive({
  options: [],
  ucDoctorId: undefined,
  doctorId: ''
})
var loading = ref(false)
const emit = defineEmits(['changeTab', 'close', 'ok'])

const defaultSummaryForm = {
  contents: '',
  cdrIds: [],
  actualDemand: '',
  callChatSummaryVO: { source: null, chatType: null }
}

const summaryForm = reactive({
  ...defaultSummaryForm
})
// const validateSwitch = () => {
//   return Promise.resolve()
// }
const isFormItemBRequired = () => {
  return summaryForm.callChatSummaryVO.chatType === 2
}

//电话记录的选择item值
const selCdrItem = ref(null)

// 需要对接
const isActualDemandRequired = computed(() => {
  return selCdrItem?.value?.actualIntent
})

const rules = computed(() => ({
  contents: [
    {
      required: true,
      trigger: ['blur'],
      message: '小结内容为必填项'
    }
  ],
  cdrIds: [{ required: isFormItemBRequired, message: '请选择电话记录', type: 'array' }],
  actualIntent: [
    {
      required: isActualDemandRequired,
      trigger: ['change'],
      message: '请选择实际诉求',
      type: 'number'
    }
  ]
}))

const actualDemandOptions = [
  {
    label: '服务咨询',
    value: 1
  },
  {
    label: '投诉建议',
    value: 2
  }
]

const showAddSummaryAlter = ref(false)
const selectChatHistoryAlter = ref(false)
//选择诊断
const handleDiagonse = val => {
  selectDiagnosesId.value = val
  const selectedList = diagnosisList.value.filter(item => val.includes(item.value))
  selectDiagnosesList.value = selectedList
  summaryForm.callChatSummaryVO.diagnosesList = selectedList.map(item => ({
    diagnosesContent: item.label,
    diagnosesId: item.value,
    diagnosesType: item.type
  }))
}
// 中西医诊断合并搜索
const getDiagnosisList = debounce(async val => {
  try {
    const params = {
      chineseMedicine: -1,
      keyword: val,
      num: 200,
      page: 1
    }
    const data = (await searchDiagnosis(params)) || [{}]
    const { result = [] } = data[0]
    const searchDiagnosisList = selectDiagnosesList.value.concat(
      result.map(item => ({
        label: item.name,
        value: item.id,
        type: item.diagnosisType //改前：1-中医诊断，0-西医诊断 // 改后：2-中医诊断，1-西医诊断
      }))
    )
    diagnosisList.value = Array.from(new Set(searchDiagnosisList))
  } catch (error) {
    console.log(error)
  }
}, 500)

const textareaInput = (e, type) => {
  const value = e.target.value
  if (type === 'contents') {
    summaryForm[type] = filterEmoij(value)
  } else {
    summaryForm.callChatSummaryVO[type] = filterEmoij(value)
  }
  nextTick(() => {
    formRef.value.validate()
  })
}
const selectHistoryList = ref([])
const deepCopyList = ref([])
// 计算选择的聊天记录时间区间
const handleTimeArea = () => {
  if (!selectHistoryList.value.length) return '请选择聊天记录'
  const timeList = selectHistoryList.value.map(m => m.timestamp)
  const minTime = min(timeList)
  const maxTime = max(timeList)
  return handleTime(minTime, maxTime)
}

const handleTime = (minTime, maxTime) => {
  if (!minTime && !maxTime) return '请选择聊天记录'
  const chatRecordStartTime = moment(minTime).format('MM-DD')
  const chatRecordEndTime = moment(maxTime).format('MM-DD')
  return chatRecordStartTime === chatRecordEndTime
    ? chatRecordStartTime
    : `${chatRecordStartTime} 至 ${chatRecordEndTime}`
}
const sendCard = throttle(chatSummaryId => {
  pushSummary({
    chatSummaryId,
    doctorAssistantName: store.getters.userInfo.realName,
    doctorPatientGroupId: workOrderGroupInfo.value.doctorPatientGroupId,
    workOrderId: _workOrderId.value
  })
    .then(res => {
      message.success('发送成功', 3)
      resetParams()
    })
    .finally(() => {
      loading.value = false
    })
})
// 展开收起
const handleFold = () => {
  othersShow.value = !othersShow.value
}
const resetParams = () => {
  emit('changeTab', 1)
  selectHistoryList.value = []
  selectHistorytext.value = ''
  selectDiagnosesId.value = []
  selectDiagnosesList.value = []
  formRef.value?.resetFields()
  showAddSummaryAlter.value = false
}

const submit = () => {
  const hasDoc = isPre.value || groupInfo.value.doctorName
  if (!hasDoc && !selDoctor.ucDoctorId) {
    message.error('请选择医生')
    return
  }
  const hasPat = isPre.value || groupInfo.value.patientProfileCommonVO?.patientProfileName
  if (!hasPat && !selPatient.ucPatientId) {
    message.error('请选择患者')
    return
  }

  loading.value = true
  handleSummaryData()
  formRef.value
    .validate()
    .then(() => {
      const msgIdList = selectHistoryList.value.map(m => m.msgId || m)
      const params = {
        ...summaryForm,
        msgIdList,
        groupId: privateId.value,
        chatSummaryId: groupInfo.value?.chatSummaryId,
        workOrderIds: _workOrderId.value ? [_workOrderId.value] : []
      }
      if (summaryForm.callChatSummaryVO.chatType !== 2) {
        params.cdrIds = []
      }
      workOrderSubmit(params)
    })
    .catch(err => {
      loading.value = false
      console.log(err)
    })
}

// 小结提交逻辑
const workOrderSubmit = params => {
  let API = ''
  if (isEdit.value) {
    API = editSummary
    params.groupId = workOrderGroupInfo?.value?.groupId
  } else {
    API = createSummary
  }

  if (summaryType.value === 1) {
    aiSummaryContents.value.imageList = fileList.value.map(it => it.filePath)
    params.contents = JSON.stringify(aiSummaryContents.value)
  }
  const isWorkplace = route.path === '/workplace'
  console.log('params', params)
  API(params).then(res => {
    emit('ok', params)
    clearStorageData(privateId.value)
    const isSendtoGroup = summaryType.value === 1 ? sendToGroup.value : true
    if (workOrderGroupInfo.value?.doctorPatientGroupId && isSendtoGroup && isWorkplace) {
      Modal.confirm({
        icon: createVNode(ExclamationCircleOutlined),
        title: () => '沟通小结已保存成功，是否发送至问诊会话中？',
        okText: () => '是',
        cancelText: () => '否',
        centered: true,
        onOk() {
          sendCard(res || groupInfo.value?.chatSummaryId)
          emit('close')
        },
        onCancel() {
          loading.value = false
          resetParams()
          emit('close')
        }
      })
    } else {
      loading.value = false
      resetParams()
      emit('close')
    }
  })
}

const checkboxChange = list => {
  deepCopyList.value = list.map(item => {
    const { timestamp, msgId } = item
    return {
      timestamp,
      msgId
    }
  })
}
const confirmHistory = () => {
  selectHistoryList.value = cloneDeep(deepCopyList.value)
  selectHistorytext.value = handleTimeArea()
  selectChatHistoryAlter.value = false
}
const cancelHistory = () => {
  Modal.confirm({
    icon: createVNode(ExclamationCircleOutlined),
    title: () => '取消后无法保存，确定取消吗？',
    okText: () => '确定',
    cancelText: () => '取消',
    onOk() {
      deepCopyList.value = cloneDeep(selectHistoryList.value)
      selectChatHistoryAlter.value = false
    },
    onCancel() {}
  })
}
const cancelConfirm = () => {
  const form = summaryForm
  const param = {
    form,
    selectHistoryList: selectHistoryList.value,
    privateId: privateId.value
  }
  if (!isEdit.value) {
    setStorageData(param)
  }
  showAddSummaryAlter.value = false
  emit('close')
}
const workOrderGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo || {})

const getListFn = cb => {
  const params = {
    ucPatientId:
      groupInfo.value?.ucUserId ||
      groupInfo.value?.ucPatientId ||
      groupInfo.value?.callChatSummary?.ucPatientId ||
      selPatient.ucPatientId ||
      null,
    ucDoctorId:
      groupInfo.value?.ucDoctorId ||
      groupInfo.value?.callChatSummary?.ucDoctorId ||
      selDoctor.ucDoctorId ||
      null,
    ucAssistantId:
      workOrderGroupInfo?.value?.bindAssistant?.ucUserId || store.getters.userId || null,
    prePatientId: groupInfo.value?.callChatSummary?.prePatientId || groupInfo.value?.prePatientId
  }
  if (params.ucPatientId || params.prePatientId) {
    getCdrPelList(params)
      .then((res = []) => {
        if (res?.length) {
          const firstData = res[0]
          res = res.filter(it => it.cdrId !== firstData.cdrId)
          res.unshift(firstData)
          cdrList.value = res.map(it => {
            return {
              ...it,
              value: it.cdrId,
              label: it.cdrInfo
            }
          })
        } else {
          cdrList.value = []
        }
      })
      .finally(() => {
        cb?.()
      })
  } else {
    cb?.()
  }
}

//   获取缓存中的小结记录
const handleStageData = () => {
  const data = getStageData(privateId.value) || {}
  summaryForm.type = summaryType.value
  // summaryForm.callChatSummaryVO.source
  // sourceType.value = TYPE[summaryType.value]?.belong // 小结来源
  sourceMapFunc()
  selectHistoryList.value = data.selectHistoryList || []
  selectHistorytext.value = handleTimeArea()
  if (data.form) {
    Object.assign(summaryForm, data.form)
  }
  // Object.assign(summaryForm, defaultSummaryForm, data.form || {})
}
// 编辑小结数据初始化
const handleOldSummaryData = () => {
  const data = groupInfo.value
  const {
    contents,
    msgIdList,
    cdrId,
    cdrIds,
    chatRecordStartTime,
    chatRecordEndTime,
    callChatSummary,
    type
  } = data
  // const source = TYPE[type]?.belong // 小结来源
  // const source = callChatSummary.source
  // console.log('来源', type)
  // sourceType.value = source
  sourceMapFunc()
  if (sourceType.value === 3) {
    const {
      chatBusinessId,
      treatmentContent,
      diagnosesList,
      medicalConditionContent,
      diagnosesList: diagnoses
    } = callChatSummary || {}
    summaryForm.callChatSummaryVO = {
      chatBusinessId,
      treatmentContent,
      medicalConditionContent,
      diagnosesList
    }
    selectDiagnosesId.value = diagnoses?.map(item => item.diagnosesId) || []
    const initDiagnoseList = diagnoses?.map(item => ({
      label: item.diagnosesContent,
      value: item.diagnosesId,
      type: item.diagnosesType
    }))
    diagnosisList.value = initDiagnoseList
    selectDiagnosesList.value = initDiagnoseList
  }
  summaryForm.callChatSummaryVO.chatType = callChatSummary.chatType
  summaryForm.type = type
  summaryForm.contents = contents
  // 小结未购买原因
  summaryForm.callChatSummaryVO.notBuyReasonType = callChatSummary.notBuyReasonType
  summaryForm.callChatSummaryVO.notBuyOtherReason = callChatSummary.notBuyOtherReason
  summaryForm.cdrIds = cdrIds?.length ? cdrIds : [cdrId]
  selectHistoryList.value = msgIdList
  selectHistorytext.value = handleChineseTime(chatRecordStartTime, chatRecordEndTime)
}
// 处理中文日期
const handleChineseTime = (minTime, maxTime) => {
  if (!minTime && !maxTime) return '请选择聊天记录'
  try {
    const start = minTime.replace('月', '-').replace('日', '')
    const end = maxTime.replace('月', '-').replace('日', '')
    return start === end ? start : `${start} 至 ${end}`
  } catch {
    return '请选择聊天记录'
  }
}

const summaryType = ref(0)
const fileList = ref([])
const aiSummaryContents = ref({
  imageList: []
})

const onSuccess = list => {
  fileList.value = list.map(it => {
    return {
      filePath: it.path,
      fileName: it.name
    }
  })
}

const _workOrderId = ref(null)
const initModal = async params => {
  console.log('params', params)

  selPatient.options = []
  selPatient.ucPatientId = undefined
  selDoctor.options = []
  selDoctor.ucDoctorId = undefined
  // 正确的方式:使用 Object.assign 重置 summaryForm
  Object.assign(summaryForm, cloneDeep(defaultSummaryForm))
  Object.assign(summaryForm, params)
  aiSummaryContents.value = {}
  privateId.value = params.privateId
  groupInfo.value = params.groupInfo
  isEdit.value = params.isEdit
  showAddSummaryAlter.value = true
  // ai小结内容处理
  summaryType.value = params.type
  // 当前工单ID
  const isArr = Array.isArray(params.workOrderId)
  if (isArr) {
    _workOrderId.value = params.workOrderId.length ? params.workOrderId : null
  } else {
    _workOrderId.value = params.workOrderId
  }
  isPre.value = [-1, 0].includes(params?.callerType)
  if (params.type === 1) {
    aiSummaryContents.value = params.aiSummaryContents || {}
    fileList.value = (params.aiSummaryContents.imageList || []).map((it, index) => {
      return {
        filePath: it,
        fileName: 'img' + index
      }
    })
  }
  getListFn(() => {
    if (params.isEdit) {
      handleOldSummaryData()
    } else {
      handleStageData()
    }
  })
  getIsShowRecommendDoctor()
  // 获取医生or患者
  if (params.callerType === 3) {
    getUserOptions(3, null, params.groupInfo.bdUcUserId)
  } else if (params.callerType === 2) {
    getUserOptions(2, params.groupInfo.ucDoctorId, null)
  }
  getPreviewId()
}

// 开关
const sendToGroup = ref(true)
const getIsShowRecommendDoctor = () => {
  isShowRecommendDoctor()
    .then(res => {
      sendToGroup.value = res
    })
    .catch(() => {
      sendToGroup.value = true
    })
}
const ReasonTypeOptions = ref([])
const getOptions = () => {
  feedbackReasonList().then(result => {
    ReasonTypeOptions.value = result.map(m => ({
      ...m,
      label: m.name,
      value: m.code
    }))
  })
}
const filterOption = (input, option) => {
  return option.label.includes(input)
}
// 查询医生or患者
//type: 3（BD）查BD下医生，2（医生）查医生下患者）
const getUserOptions = (type, ucDoctorId, bdUcUserId) => {
  const params = {
    type: type,
    ucDoctorId: ucDoctorId,
    bdId: bdUcUserId
  }
  getDoctorPatients(params).then(result => {
    const { doctorList = [], patientList = [] } = result
    if (type === 3) {
      selDoctor.options = doctorList.map(m => {
        return {
          label: m.doctorName,
          value: m.ucDoctorId,
          ...m
        }
      })
    } else if (type === 2) {
      selPatient.options = patientList.map(m => {
        return {
          label: m.patientName,
          value: m.ucPatientId,
          ...m
        }
      })
    }
  })
}
// 选择医生患者 type 3医生，2患者
const onSelect = (type, option) => {
  selectHistoryList.value = []
  selectHistorytext.value = ''
  const clearPatient = () => {
    selPatient.ucPatientId = null
    selPatient.patientName = null
    selPatient.gender = null
    selPatient.age = null
    // selPatient.options = []
    groupInfo.value.patientProfileCommonVO.gender = null
    groupInfo.value.patientProfileCommonVO.age = null
    privateId.value = null
    cdrList.value = []
  }
  if (type === 3) {
    if (option) {
      selDoctor.ucDoctorId = option.ucDoctorId
      selDoctor.doctorId = option.doctorId
      selDoctor.doctorName = option.doctorName
      getUserOptions(2, option.ucDoctorId, null)
    } else {
      selDoctor.ucDoctorId = null
      selDoctor.doctorId = null
      selDoctor.doctorName = null
    }
    selPatient.options = []
    clearPatient()
  } else if (type === 2) {
    if (option) {
      selPatient.ucPatientId = option.ucPatientId
      selPatient.patientName = option.patientName
      selPatient.gender = option.gender
      selPatient.age = option.age
      groupInfo.value.patientProfileCommonVO.gender = option.gender
      groupInfo.value.patientProfileCommonVO.age = option.age
      getPreviewId()
      getListFn()
    } else {
      clearPatient()
    }
  }
}
onMounted(() => {
  getOptions()
})
defineExpose({ initModal })
// 手动给 summaryForm 进行复值( 患者信息 or 医生信息不全的情况下 )
const handleSummaryData = () => {
  // 如果医生患者都没有改变直接退出
  const hasVal = selDoctor.ucDoctorId || selPatient.ucPatientId
  if (!hasVal) return
  // 判断是否有医生信息
  if (selDoctor.ucDoctorId) {
    summaryForm.ucDoctorId = selDoctor.ucDoctorId
    summaryForm.doctorName = selDoctor.doctorName
    summaryForm.callChatSummaryVO.ucDoctorId = selDoctor.ucDoctorId
    summaryForm.callChatSummaryVO.doctorName = selDoctor.doctorName
    summaryForm.callChatSummaryVO.doctorId = selDoctor.doctorId
  }
  // 判断是不是有患者信息
  if (selPatient.ucPatientId) {
    summaryForm.patientName = selPatient.patientName
    summaryForm.ucPatientId = selPatient.ucPatientId
    summaryForm.callChatSummaryVO.ucPatientId = selPatient.ucPatientId
    summaryForm.callChatSummaryVO.prePatientId = null
    summaryForm.callChatSummaryVO.patientName = selPatient.patientName
  }
}
const openChatHistory = () => {
  // 判断私聊是否存在
  if (privateId.value) {
    selectChatHistoryAlter.value = true
  } else {
    message.warn('缺少私聊ID,暂无数据')
  }
}
// 查询私聊ID
const getPreviewId = () => {
  const ucDoctorId = groupInfo.value.ucDoctorId || selDoctor.ucDoctorId,
    ucPatientId = groupInfo.value.ucPatientId || selPatient.ucPatientId
  if (!ucDoctorId || !ucPatientId) return
  const params = [
    {
      ucDoctorId: ucDoctorId,
      ucPatientId: ucPatientId,
      groupType: 2
    }
  ]
  privateId.value = null
  getGroupByUcUserIds(params).then((result = []) => {
    console.log(result)
    if (result.length) {
      const [res] = result
      const { assistantPatientGroupId } = res
      privateId.value = assistantPatientGroupId
    }
  })
}
// 对 type 进行映射 source
const sourceMapFunc = () => {
  const type = summaryType.value
  // 兼容老业务，type 10 的时候，source 也是10的历史数据问题
  if (type === 10) {
    const source = isEdit.value
      ? groupInfo.value.callChatSummary.source
      : summaryForm.callChatSummaryVO.source
    sourceType.value = source === 4 ? 4 : 3
  } else {
    sourceType.value = TYPE.find(item => item.value === type)?.belong
  }
}
</script>
<style lang="scss" scoped>
.patient-info {
  background-color: #fff;

  .user-info-wrap {
    background-color: #fff;
    padding: 10px 0;
    margin: 0 24px;
    border-bottom: 1px solid #e8e8e8;

    .line {
      display: flex;
      padding: 7px 0;

      .user-info-item {
        height: 30px;
        line-height: 30px;
        padding: 0 48px 0 16px;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 14px;
        color: #333;
        border-right: 1px solid #e8e8e8;
        span {
          color: #999;
        }
        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          border-right: none;
        }
      }
      .user-info-select {
        width: 200px;
      }
    }
  }
}
.add-summary-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  ::v-deep(.ant-form-item-label > label) {
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }
  ::v-deep(.ant-form-item-label > label) {
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }
  ::v-deep(.ant-form-item-required) {
    color: #999;
    white-space: pre-wrap;
    font-size: 12px;
  }
  .basic {
    flex: 1;
    padding: 15px 24px 20px 24px;
    background-color: #fff;
  }
  .custom-label {
    .text {
      font-weight: 500;
      font-size: 14px;
      color: #333;
    }
    .tips {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #ffa940;
    }
  }
  .textarea-form-item {
    position: relative;
    .text-tips {
      opacity: 0.6;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 10px;
      color: #999999;
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  .aiFormItem {
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 6px;

    .labels {
      text-align: right;
      display: inline-block;
      min-width: 100px;
    }
  }
  .search-input {
    height: 36px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 12px;
    color: #333333;
    box-sizing: border-box;
    padding: 8px 12px;
    background: rgba(250, 250, 250, 0.5);
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: auto !important;
    pointer-events: initial !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.textarea {
      box-sizing: border-box;
      height: 260px;
      resize: none;
    }
    .right-icon {
      color: #d9d9d9;
      font-size: 14px;
    }
  }
}
.title {
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  .left {
    font-weight: 500;
    font-size: 16px;
    color: #333;
  }
  .right {
    font-weight: 400;
    font-size: 14px;
    color: #1989fa;
    cursor: pointer;
  }
}
.others-box {
  margin-top: 10px;
  .others {
    padding: 20px 24px;
    background-color: #fff;
  }
}

.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
.notBuyReason {
  .Reason_header {
    display: flex;
    .Reason_title {
      font-size: 14px;
      color: #333333;
    }
    .Reason_tips {
      font-weight: 500;
      font-size: 14px;
      color: #ff9412;
      margin-left: 8px;
    }
  }
}
</style>
